import React, { Component } from 'react'
import styled from 'styled-components'
import withLoading from '../../hoc/Loading'
import CampCharacter from './components/CampCharacter'
import { ICampPlayerData } from '../../helpers/data/campPlayer'
import campPositionsHelper from '../../helpers/campPositionsHelper'
import LoadingWheel from '../../components/loadingWheel/LoadingWheel'
import getPalette, { IPalette } from '../../helpers/colors/colors'
import MainButton from '../../components/buttons/MainButton'
import Asset from '../../components/asset/Asset'
import { IAssetData } from '../../helpers/data/assetData'
import { ReactComponent as StartIcon } from '../../assets/icons/start-button.svg'
import AnimationsToggle from '../teacherGame/components/AnimationsToggle'

const palette: IPalette = getPalette()

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`
const BackgroundContainer = styled.div`
	width: 100%;
	height: 100%;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
`

const WaitingBar = styled.div`
	width: 100%;
	height: 8%;
	background-color: rgb(0, 87, 133);
	color: rgba(255, 255, 255, 1);
	display: flex;
	font-size: 7px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 10000;

	@media (min-width: 600px) {
		font-size: 16px;
	}

	@media (min-width: 1500px) {
		font-size: 20px;
	}
`

const LoadingContainer = styled.div`
	flex: 1 1 0;
	height: 96%;
	padding: 2%;
	display: inline-block;
`

const LoadingAnimation = styled.div`
	width: 2%;
	height: 96%;
	display: inline-block;
`

const MainButtonContainer = styled.div`
	flex: 0 1 0;
	height: 100%;
	font-size: 70%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-right: 8px;

	@media (min-width: 600px) {
		padding-right: 16px;
		font-size: 11px;
	}

	@media (min-width: 900px) {
		font-size: 14px;
	}
`

const AnimationsToggleWrapper = styled.div`
	position: absolute;
	bottom: calc(8% + 15px);
	right: 15px;
	z-index: 10001;
`

export interface ISkin {
	background: IAssetData
	bottomBar: ISkinBottomBar
}

interface ISkinBottomBar {
	backgroundColor: string
	buttonBackgroundColor: string
}

interface IWaitingProps {
	players: ICampPlayerData[]
	playerUID: string
	onViewLoaded: () => void
	onStart: () => void
	isTeacher: boolean
	scale: number
	skin: ISkin
	areAnimationsEnabled?: boolean
	onAnimationsToggle?: (enabled: boolean) => void
}

class Waiting extends Component<IWaitingProps> {
	static defaultProps = {
		scale: 1,
	}

	buildCharacters(characters: ICampPlayerData[]) {
		const max_visible_character = 20
		let filteredCharacter = characters
		const playerIndex = characters.findIndex((character) => character.playerUID === this.props.playerUID)
		if (playerIndex !== -1) {
			filteredCharacter = [
				characters[playerIndex],
				...characters.slice(0, playerIndex),
				...characters.slice(playerIndex + 1),
			]
		}
		filteredCharacter = filteredCharacter.filter((character, index) => index <= max_visible_character)
		return filteredCharacter.map((character: ICampPlayerData) => {
			return (
				<CampCharacter
					key={character.playerUID}
					uid={character.playerUID + character.avatarId}
					isHighlighted={character.playerUID === this.props.playerUID}
					asset={character.avatarAsset}
					nickname={character.nickname}
					scale={this.props.scale}
					pos={campPositionsHelper(character.order)}
					areAnimationsEnabled={this.props.areAnimationsEnabled}
				/>
			)
		})
	}

	canSubmit() {
		return this.props.isTeacher && this.props.players.length
	}

	submit = () => {
		if (this.canSubmit()) {
			this.props.onStart()
		}
	}

	onImageLoaded = () => {
		this.props.onViewLoaded()
	}

	onAnimationsToggle = () => {
		if (this.props.onAnimationsToggle) {
			this.props.onAnimationsToggle(!this.props.areAnimationsEnabled)
		}
	}

	render() {
		const barText = this.props.isTeacher
			? `Waiting for players, ${this.props.players.length} connected. Hit Start game when ready!`
			: 'Waiting for players…'

		const startButtonBackgroundColor = palette.radiantBlue

		return (
			<Wrapper>
				<BackgroundContainer>
					<Asset onLoad={this.onImageLoaded} asset={this.props.skin.background} />
				</BackgroundContainer>
				{this.buildCharacters(this.props.players)}
				<AnimationsToggleWrapper>
					<AnimationsToggle
						enabled={this.props.areAnimationsEnabled !== false}
						onToggle={this.onAnimationsToggle}
						disableResponsiveResize={true}
					/>
				</AnimationsToggleWrapper>
				<WaitingBar
					style={{
						backgroundColor: `${palette.blackDark}`,
						borderTop: this.props.isTeacher ? '1px solid white' : '0px',
					}}
				>
					<LoadingContainer>
						<LoadingAnimation>
							<LoadingWheel areAnimationsEnabled={this.props.areAnimationsEnabled} />
						</LoadingAnimation>
						<span style={{ paddingLeft: '1.8%' }}>{barText}</span>
					</LoadingContainer>
					<MainButtonContainer
						style={{
							visibility: this.props.isTeacher ? 'visible' : 'hidden',
							//flex
						}}
					>
						<MainButton
							text={'Start game'}
							onSubmit={this.submit}
							isDisabled={!this.canSubmit()}
							isRounded={true}
							backgroundColor={startButtonBackgroundColor}
							Icon={<StartIcon />}
						/>
					</MainButtonContainer>
				</WaitingBar>
			</Wrapper>
		)
	}
}

export default withLoading(Waiting)
